import { WatchQueryFetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

export const useMatterDocumentQuery = (params: MatterDocumentParams, fetchPolicy?: WatchQueryFetchPolicy) => {
    const documentQuery = useQuery<MatterDocumentData, MatterDocumentParams>(DocumentQuery, {
        fetchPolicy: fetchPolicy,
        variables: {
            ...params
        }
    });

    return {...documentQuery};
};

export interface MatterDocumentParams {
    id: string;
    filter: string;
    offset?: number;
    first?: number;
    typeFilter?: string;
}

export interface MatterDocumentData {
    matter: Matter;
}

export interface Matter {
    id:        number;
    documents: MatterDocuments;
}

export interface MatterDocuments {
    recordCount: number;
    documents:   MatterDocument[];
}

export interface MatterDocument {
    matterDocumentId: number;
    documentId:       number;
    matterId:         number;
    title:            string;
    name:             string;
    type:             string;
    originatingType:  string;
    addedBy:          string;
    notes:            string;
    creationDate:     Date;
    isUserDocument:   boolean;
    convertMail:      boolean;
}

export const DocumentQuery = gql`
    query DocumentData($id: Int!, $filter: String, $offset: Int, $first: Int, $typeFilter: String){
        matter(id: $id) {
            id,
            documents(filter: $filter, offset: $offset, first: $first, typeFilter: $typeFilter) {
                recordCount
                documents {
                    matterDocumentId
                    documentId
                    matterId
                    title
                    name
                    type
                    originatingType
                    addedBy
                    notes
                    creationDate
                    isUserDocument
                    convertMail
                }
            }
        }
    }
`;
